// ResidentialAddressForm.js

import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Form, Input, Row, Col, Select, Button, Checkbox } from 'antd';
import { validationRules } from '../../devUtils';
import { ResidentialAddressFormProps, ResidentialAddressFormmapStateToProps } from './IndusindMinKycDataHandler';

const { Option } = Select;

class ResidentialAddressForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      preferredAddressChecked: this.props.checkboxValue,
    };
    this.handleResidentialFormSubmit = this.handleResidentialFormSubmit.bind(this);
  }

  componentDidMount() {
    const {
      IndusindMinKycUserInfo: {
        data: {
          client_kyc_upload: {
            preferred_address = {},
            residential_address = {},
          } = {},
        } = {},
      } = {},
      onInitIndusindMinKycCities,
      form: {
        getFieldValue,
      } = {},
    } = this.props;
    if (preferred_address && preferred_address.state_id) {
      onInitIndusindMinKycCities({ id: preferred_address.state_id });
    } else if (getFieldValue('preferred_state')) {
      onInitIndusindMinKycCities({ id: getFieldValue('preferred_state') });
    }
    if (residential_address && residential_address.state_id) {
      onInitIndusindMinKycCities({ id: residential_address.state_id });
    } else if (getFieldValue('residential_state')) {
      onInitIndusindMinKycCities({ id: getFieldValue('residential_state') });
    }
  }

  handleResidentialFormSubmit(evt) {
    evt.preventDefault();
    const { form: { validateFields }, handleNextStep } = this.props;
    const { preferredAddressChecked } = this.state;
    validateFields((err, values) => {
      if (!err) {
        handleNextStep(1, values, preferredAddressChecked);
      }
    });
  }

  handlePrevious() {
    const { form: { validateFields }, handlePrevStep } = this.props;
    const { preferredAddressChecked } = this.state;
    validateFields((err, values) => {
      handlePrevStep(1, values, preferredAddressChecked);
    });
  }

  handleResidentialStateChange(selectedResidentialStateId) {
    const { onInitIndusindMinKycCities } = this.props;
    onInitIndusindMinKycCities({ id: selectedResidentialStateId });
  }

  handlePreferredStateChange(selectedPreferredStateId) {
    const { onInitIndusindMinKycCities } = this.props;
    onInitIndusindMinKycCities({ id: selectedPreferredStateId });
  }

  handleResidentialCityChange(selectedResidentialCityId) {
    const {
      onInitIndusindMinKycCities,
    } = this.props;
    onInitIndusindMinKycCities({ id: selectedResidentialCityId });
  }

  handlePreferredCityChange(selectedPreferredCityId, selectedPreferredCityName) {
    const { onInitIndusindMinKycCities } = this.props;
    onInitIndusindMinKycCities({ id: selectedPreferredCityId, cityName: selectedPreferredCityName });
  }

  handleCheckBoxChange(checked) {
    const {
      form,
      form: {
        getFieldValue,
      } = {},
      onInitIndusindMinKycCities,
    } = this.props;
    if (checked) {
      this.setState({
        preferredAddressChecked: true,
      });
      form.setFieldsValue({
        preferred_address_1: getFieldValue('residential_address_1') || '',
        preferred_address_2: getFieldValue('residential_address_2') || '',
        preferred_address_3: getFieldValue('residential_address_3') || '',
        preferred_city: getFieldValue('residential_city') || '',
        preferred_state: getFieldValue('residential_state') || '',
        preferred_country: getFieldValue('residential_country') || '',
        preferred_pincode: getFieldValue('residential_pincode') || '',
      });
      if (getFieldValue('residential_state')) {
        onInitIndusindMinKycCities({ id: getFieldValue('residential_state') });
      }
    } else {
      this.setState({
        preferredAddressChecked: false,
      });
      form.setFieldsValue({
        preferred_address_1: '',
        preferred_address_2: '',
        preferred_address_3: '',
        preferred_city: '',
        preferred_state: '',
        preferred_country: '',
        preferred_pincode: '',
      });
    }
  }

  renderResidentialAddress() {
    const {
      form: {
        getFieldDecorator,
        getFieldValue,
      } = {},
      IndusindMinKycUserInfo: {
        data: {
          states = [],
        } = {},
      } = {},
      IndusindMinKycCities: {
        data: cities = [],
      } = {},
      residentialAddressValues,
      preferredAddressValues,
    } = this.props;
    const {
      preferredAddressChecked,
    } = this.state;
    return (
      <Form
        onSubmit={this.handleResidentialFormSubmit}
        layout="vertical"
      >
        <Row align="middle" type="flex" justify="start" gutter={20}>
          <Col xs={24} sm={24} md={24} lg={24} xl={24}>
            <Row align="middle" type="flex" justify="start" gutter={30}>
              <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                <Form.Item label="Residential Address Line 1">
                  {getFieldDecorator('residential_address_1', {
                    rules: [validationRules.mandatory],
                    initialValue: residentialAddressValues.address_line1 || undefined,
                  })(
                    <Input
                      className="custom-input"
                      placeholder="Enter Residential Address Line 1"
                    />
                  )}
                </Form.Item>
              </Col>
              <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                <Form.Item label="Residential Address Line 2">
                  {getFieldDecorator('residential_address_2', {
                    rules: [validationRules.mandatory],
                    initialValue: residentialAddressValues.address_line2 || undefined,
                  })(
                    <Input
                      className="custom-input"
                      placeholder="Enter Residential Address Line 2"
                    />
                  )}
                </Form.Item>
              </Col>
              <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                <Form.Item label="Residential Address Line 3">
                  {getFieldDecorator('residential_address_3', {
                    rules: [validationRules.mandatory],
                    initialValue: residentialAddressValues.address_line3 || undefined,
                  })(
                    <Input
                      className="custom-input"
                      placeholder="Enter Residential Address Line 3"
                    />
                  )}
                </Form.Item>
              </Col>
              <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                <Form.Item label="Residential Country">
                  {getFieldDecorator('residential_country', {
                    rules: [validationRules.mandatory],
                    initialValue: 'INDIA',
                  })(
                    <Input
                      className="custom-input"
                      disabled
                    />
                  )}
                </Form.Item>
              </Col>
            </Row>
            <Row align="middle" type="flex" justify="start" gutter={30}>
              <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                <Form.Item label="Residential State">
                  {getFieldDecorator('residential_state', {
                    rules: [validationRules.mandatory],
                    initialValue: residentialAddressValues.state_id || undefined,
                  })(
                    <Select
                      className="custom-select"
                      placeholder="Select Your Residential State"
                      onChange={(selectedResidentialStateId) => this.handleResidentialStateChange(selectedResidentialStateId)}
                    >
                      {states && states.length && states.map(({ id = '', name = '' }) => (
                        <Option key={id} value={id}>
                          {name}
                        </Option>
                      ))}
                    </Select>
                  )}
                </Form.Item>
              </Col>
              <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                <Form.Item label="Residential City">
                  {getFieldDecorator('residential_city', {
                    rules: [validationRules.mandatory],
                    initialValue: residentialAddressValues.city_id || undefined,
                  })(
                    <Select
                      className="custom-select"
                      placeholder="Select Your Residential City"
                      onChange={(selectedResidentialCityId) => this.handleResidentialCityChange(selectedResidentialCityId)}
                    >
                      {cities && cities.length && cities.map(({ id = '', name = '' }) => (
                        <Option key={id} value={id}>
                          {name}
                        </Option>
                      ))}
                    </Select>
                  )}
                </Form.Item>
              </Col>
              <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                <Form.Item label="Residential Pincode">
                  {getFieldDecorator('residential_pincode', {
                    rules: [validationRules.validIndianPincode],
                    initialValue: residentialAddressValues.pincode || undefined,
                  })(
                    <Input
                      className="custom-input"
                      placeholder="Enter Pincode"
                    />
                  )}
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                <Form.Item>
                  <Checkbox
                    checked={preferredAddressChecked}
                    onChange={({ target: { checked } }) => this.handleCheckBoxChange(checked)}
                  >
                    Preferred address same as above
                  </Checkbox>
                </Form.Item>
              </Col>
            </Row>
            <Row align="middle" type="flex" justify="start" gutter={20}>
              <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                <Row align="middle" type="flex" justify="start" gutter={30}>
                  <Fragment>
                    <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                      <Form.Item label="Preferred Address Line 1">
                        {getFieldDecorator('preferred_address_1', {
                          rules: [validationRules.mandatory],
                          initialValue: preferredAddressChecked ? getFieldValue('residential_address_1') || '' : residentialAddressValues.address_line1 || preferredAddressValues.address_line1 || undefined,
                        })(
                          <Input
                            className="custom-input"
                            placeholder="Enter Preferred Address Lane 1"
                            disabled={preferredAddressChecked}
                          />
                        )}
                      </Form.Item>
                    </Col>
                    <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                      <Form.Item label="Preferred Address Line 2">
                        {getFieldDecorator('preferred_address_2', {
                          rules: [validationRules.mandatory],
                          initialValue: preferredAddressChecked ? getFieldValue('residential_address_2') : residentialAddressValues.address_line2 || preferredAddressValues.address_line2 || undefined,
                        })(
                          <Input
                            className="custom-input"
                            placeholder="Enter Preferred Address Lane 2"
                            disabled={preferredAddressChecked}
                          />
                        )}
                      </Form.Item>
                    </Col>
                    <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                      <Form.Item label="Preferred Address Line 3">
                        {getFieldDecorator('preferred_address_3', {
                          rules: [validationRules.mandatory],
                          initialValue: preferredAddressChecked ? getFieldValue('residential_address_3') || '' : residentialAddressValues.address_line3 || preferredAddressValues.address_line3 || undefined,
                        })(
                          <Input
                            className="custom-input"
                            placeholder="Enter Preferred Address Lane 3"
                            disabled={preferredAddressChecked}
                          />
                        )}
                      </Form.Item>
                    </Col>
                    <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                      <Form.Item label="Preferred Country" >
                        {getFieldDecorator('preferred_country', {
                          rules: [validationRules.mandatory],
                          initialValue: 'INDIA',
                        })(
                          <Input
                            className="custom-input"
                            disabled
                          />
                        )}
                      </Form.Item>
                    </Col>
                  </Fragment>
                </Row>
                <Row align="middle" type="flex" justify="start" gutter={30}>
                  <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                    <Form.Item label="Preferred State" className="margin-b-1" >
                      {getFieldDecorator('preferred_state', {
                        rules: [validationRules.mandatory],
                        initialValue: preferredAddressChecked ? getFieldValue('residential_state') : residentialAddressValues.state_id || preferredAddressValues.state_id || undefined,
                      })(
                        <Select
                          className="custom-select"
                          placeholder="Select Your Preferred State"
                          filterOption={false}
                          disabled={preferredAddressChecked}
                          onChange={(selectedPreferredStateId) => this.handlePreferredStateChange(selectedPreferredStateId)}
                        >
                          {states && states.length && states.map(({ id = '', name = '' }) => (
                            <Option key={id} value={id}>
                              {name}
                            </Option>
                          ))}
                        </Select>
                      )}
                    </Form.Item>
                  </Col>
                  <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                    <Form.Item label="Preferred City">
                      {getFieldDecorator('preferred_city', {
                        rules: [validationRules.mandatory],
                        initialValue: preferredAddressChecked ? getFieldValue('residential_city') : residentialAddressValues.city_id || preferredAddressValues.city_id || undefined,
                      })(
                        <Select
                          className="custom-select"
                          placeholder="Select Your Preferred City"
                          disabled={preferredAddressChecked}
                          onChange={(selectedPreferredCityId, selectedPreferredCityName) => this.handlePreferredCityChange(selectedPreferredCityId, selectedPreferredCityName)}
                        >
                          {cities && cities.length && cities.map(({ id = '', name = '' }) => (
                            <Option key={id} value={id}>
                              {name}
                            </Option>
                          ))}
                        </Select>
                      )}
                    </Form.Item>
                  </Col>
                  <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                    <Form.Item label="Preferred Pincode">
                      {getFieldDecorator('preferred_pincode', {
                        rules: [validationRules.validIndianPincode],
                        initialValue: preferredAddressChecked ? getFieldValue('residential_pincode') : residentialAddressValues.pincode || preferredAddressValues.pincode || undefined,
                      })(
                        <Input
                          className="custom-input"
                          placeholder="Enter Pincode"
                          disabled={preferredAddressChecked}
                        />
                      )}
                    </Form.Item>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Col>
        </Row>
        <div className="text-right">
          <Button
            className="margin-1 width-2"
            type="default"
            onClick={() => this.handlePrevious()}
          >
            Previous
          </Button>
          <Button
            className="green-btn margin-1 width-2"
            htmlType="submit"
          >
            Next
          </Button>
        </div>
      </Form>
    );
  }

  render() {
    return (
      <Fragment>
        {this.renderResidentialAddress()}
      </Fragment>
    );
  }
}

ResidentialAddressForm.propTypes = ResidentialAddressFormProps;


const ResidentialAddressFormWrapper = Form.create({ name: 'normal_admin' })(ResidentialAddressForm);
export default connect(ResidentialAddressFormmapStateToProps, null)(ResidentialAddressFormWrapper);
export { ResidentialAddressForm, ResidentialAddressFormWrapper };



// WEBPACK FOOTER //
// client/containers/IndusindMinKyc/ResidentialAddressForm.js